export const Alert = {
  transclude: true,

  bindings: {
    type: '@',
  },

  template: `
    <div class="alert alert-{{ $ctrl.type }} text-center mb-4">
      <ng-transclude></ng-transclude>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/Alert/Alert.js